<template>
    <div id="app">
        <cotton-home/>
        <div id='captcha-box' class='cotton_captcha'></div>
    </div>
</template>

<script>
import CottonHome from '@/components/common/Home.vue';

export default {
    name: "app",
    components: { CottonHome },
    
}
</script>

<style lang="scss">
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
    
    .cotton_captcha {
        width: 100%;
        position: fixed;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
    }
</style>
